import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

interface UpdateProfileResponse {
  updateProfile: {
    body: {
      data: unknown;
      message: string;
      success: boolean;
    };
    status_code: number;
  };
}

export const UPDATE_PROFILE = gql`
  mutation updateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      body {
        data
        message
        success
      }
      status_code
    }
  }
`;

export const useUpdateProfile = (
  options?: MutationHookOptions<UpdateProfileResponse, OperationVariables>,
) => {
  return useMutation(UPDATE_PROFILE, options);
};
